// extracted by mini-css-extract-plugin
module.exports = {"content":"TermsConditions_content___iUQD","titleModal":"TermsConditions_titleModal__v3IVi","modalBody":"TermsConditions_modalBody____Mh4"};